import { render, staticRenderFns } from "./AdminPurchase.vue?vue&type=template&id=50b7a7f8&scoped=true&"
import script from "./AdminPurchase.vue?vue&type=script&lang=js&"
export * from "./AdminPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b7a7f8",
  null
  
)

export default component.exports